import * as emailSettings from './list'

export const allEmailSettings = Object.values(emailSettings)
